import React from 'react';
import LegalDocumentSection from 'desktop/components/legalDocument/LegalDocumentSection';
import { useTranslation } from 'react-i18next';
import { LegalDocument } from 'commons/legalDocument/legalDocumentObject';
import ExpandableHeader from 'desktop/components/commons/ExpandableHeader';
import { ScrollbarProvider } from 'desktop/components/containers/ScrollbarProvider';
import SmoothScroll from 'desktop/components/containers/SmoothScroll';
import DownloadSection from '../sections/DownloadSection';
import Footer from '../sections/Footer';

const PrivacyPolicy = () => {
  const { t } = useTranslation('privacyPolicy');
  const privacyPolicy: LegalDocument = t('legalDocument', { returnObjects: true });

  return (
    <ScrollbarProvider>
      <ExpandableHeader />
      <SmoothScroll childrenFadeIn={true}>
        <LegalDocumentSection inputText={privacyPolicy} />
        <DownloadSection
          subtitle={t('home:download.subtitle')}
          title={t('home:download.title')}
          downloadTitle={t('home:download.download-title')}
        />
        <Footer />
      </SmoothScroll>
    </ScrollbarProvider>
  );
};

export default PrivacyPolicy;
